<input type="text" placeholder="{{placeholder}}" class="{{class}}" *ngIf="!isAutoComplete && !formContrl" #searchElement
    (blur)="onBlur()" aria-label="Search....">

<input type="text" placeholder="{{placeholder}}" class="{{class}}" *ngIf="!isAutoComplete && formContrl"
    [formControl]="formContrl" (blur)="onBlur()" aria-label="Search....">

<ng-container *ngIf="isAutoComplete">
    <input type="text" placeholder="{{placeholder}}" class="{{class}}" #searchElement [matAutocomplete]="autoRef"
        *ngIf="!formContrl" aria-label="Search....">
    <input type="text" placeholder="{{placeholder}}" class="{{class}}" [formControl]="formContrl"
        [matAutocomplete]="autoRef" *ngIf="formContrl" aria-label="Search....">
</ng-container>